module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy-3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("If you have difficulty in obtaining any of the materials")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("and equipment mentioned in this book, please visit")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("the Search Press website for details of suppliers:")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.searchpress.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.searchpress.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy-3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Publishers’ note")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All the step-by-step photographs in this book feature")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("the author, Geoff Kersey, demonstrating how to paint")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("in watercolour. No models have been used.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2-t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/02_Halftitle#page_1"
    }
  }, [_vm._v("Page 1")])]), _vm._v(" "), _c('p', {
    staticClass: "copy-22"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Boatyard at Woodbridge")])]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("340 x 270mm (13½ x 10½in)")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("Here the positioning of the boats leads the eye to the")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("distant area just to the right of the whitewashed building.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("Note that the planks of timber at the bottom right plus the")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("suggested lines on the yard also point to this area. There is")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("no mistaking where we are meant to look in this scene.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2-t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Dedication#page_2"
    }
  }, [_vm._v("Pages 2–3")])]), _vm._v(" "), _c('p', {
    staticClass: "copy-22"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dunwich Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("610 x 394mm (24 x 15½in)")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("I love to paint this type of scene, so typical of the Norfolk")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("and Suffolk coasts, where the landscape is dominated by")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("huge skies. Note how a second glaze was used after the")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("first one had dried, leaving a small area in the top third")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("where the viewer glimpses a patch of light. The small")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("cliffs, old hut and beached boats lend just enough interest")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("without making the scene too cluttered.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2-t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#page_7"
    }
  }, [_vm._v("Opposite")])]), _vm._v(" "), _c('p', {
    staticClass: "copy-22"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bluebell Wood")])]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("305 x 446mm (12 x 18in)")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("Unusually for me, this scene has not even a glimpse of sky")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("– instead the mass of greenery encourages the viewer to")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("focus on the carpet of bluebells, created using a mixture")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("of cobalt blue and cobalt violet. Note how the positioning")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("of the trees uses linear perspective to lead the viewer into")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2a"
  }, [_vm._v("the painting.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1954e6ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Suppliers.vue
// module id = 75
// module chunks = 0